import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { url } from '../../../../configlink';
import { useSelector } from 'react-redux';

const EditAccount = () => {

    let loc = useLocation();
    // const token = localStorage.getItem("token");

	let adminUser = useSelector((state) => state.userAdmin.userAdmin)

    let [data, setData] = useState([]);

    let [updateData, setUpdateData] = useState({})

    let userId = loc.search.split('=')[1]
    
    useEffect(() => {
        getUserDetails()
    }, [])

    function getUserDetails () {
        try {
            fetch(`${url}/api/admin/userdetails?UserId=${userId}`, {
                method: 'GET',
				credentials: 'include',
				headers: {
					'acgt-admin': adminUser
				},
            })
            // fetch(`${url}/api/admin/userdetails?UserId=18749`)
                .then((res) => res.json())
                .then((data) => {
                    console.log(data);   
                    if(data.result){
                        setData(data.result[0])
                        getAllOrgs()
                    }   
                })
                .catch(err => {
                    console.error(err);  
                })
        } catch (error) {
            console.error(error);
        }
    }
    
    let [allCompanies, setAllCompanies] = useState([])
    
    function getAllOrgs(){
        
        try {
            fetch(`${url}/api/admin/get_corporate_lists`, {
                method: "GET",
				credentials: 'include',
				headers: {
					'acgt-admin': adminUser
				},
            })
                .then((res) => res.json())
                .then((data2) => {
                    console.log("all data",data2);
                    
                    let sortedData = data2.sort((a,b) => {
                        if (a.CorporateName.toLowerCase() < b.CorporateName.toLowerCase()) return -1; 
                        if (a.CorporateName.toLowerCase() > b.CorporateName.toLowerCase()) return 1;  
                        return 0; 
                    })
                    console.log("sorted",sortedData);
                     
                    setAllCompanies(data2)                    
                })
                .catch(err => {
                    console.error(err);  
                })
        } catch (error) {
            console.error(error);
            
        }
        
    }
    
    
    const updateContent = () => {
        console.log('update', updateData);
        let userId = data.UserId
        console.log("id", userId);
        
        try {
            fetch(`${url}/api/admin/update_user_details?id=${userId}`,{
                    method:"PUT",
                    credentials: 'include',
                    headers:{
						"Content-Type": "application/json",
						'acgt-admin': adminUser
                    },
                    body: JSON.stringify(updateData)
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log(data);   
                    if(data.message === 'success'){
                        alert("Success")   
                        getUserDetails()                     
                    }                 
                })
                .catch(err => {
                    console.error(err);  
                })
        } catch (error) {
            console.error(error);
            
        }
    }
    

  return (
    <>
    { data && !Array.isArray(data) ? 
    <>
    <div className='p-2'>
        <h1 className='text-2xl font-bold'>User Details</h1>
        <div className='border border-black p-2 text-[13px] flex flex-col gap-[5px]'>
            <div className='flex bg-gray-100 py-1'>
                <p className='min-w-[250px] '>UserId:</p>
                <p className='font-bold'>{data.UserId} (Automatically Assgined)</p>
            </div>
            <div className='flex py-1'>
                <p className='min-w-[250px]'>Organization Name:</p>
                <select 
                name="orgname" 
                id="orgname" 
                className='w-full border border-black'
                
                value={data.CorporateId}
                onChange={(e) => {

                    let val = e.target.value
                    
                    setUpdateData({
                        ...updateData, 
                        CorporateId: parseInt(val)
                    })

                    setData({...data, CorporateId:val})
                }}
                >   
                {allCompanies.map((x,i) => (
                    <option key={i} value={x.CorporateId}>{x.CorporateName}</option>
                ))}
                </select>
            </div>
            <div className='flex bg-gray-100 py-1'>
                <p className='min-w-[250px]'>User Name:</p>
                <div>
                    <input type="text" className='border border-black px-2  w-[250px]' 
                    value={data.UserName} 
                    onChange={(e) => {
                        setUpdateData({
                            ...updateData, 
                            UserName: e.target.value
                        })
    
                        setData({...data, UserName:e.target.value})
                    }}
                    />
                    <p className='font-bold'>At least 8 digits</p>
                </div>
            </div>
            <div className='flex py-1'>
                <p className='min-w-[250px]'>E-Mail Address:</p>
                <div>
                    <input type="text" className='border border-black px-2  w-[250px]' 
                    value={data.EmailAddress} 
                    onChange={(e) => {
                        setUpdateData({
                            ...updateData, 
                            EmailAddress: e.target.value
                        })
    
                        setData({...data, EmailAddress:e.target.value})
                    }}
                    />
                    <p className='font-bold'>{`Please don't leave it blank`}</p>
                </div>
            </div>
            <div className='flex bg-gray-100 py-1'>
                <p className='min-w-[250px]'>Password:</p>
                <div>
                    <input type="text" className='border border-black px-2  w-[250px]' 
                    value={updateData.Password}
                    onChange={(e) => {
                        setUpdateData({
                            ...updateData, 
                            Password: e.target.value
                        })
                    }}
                    />
                    <div className='flex flex-col'>
                        <p className='font-bold'>{`Leave blank if you don't want to change the password.`}</p>
                        <p className='font-bold'>{`At least 8 digits with one capital letter, one numeric and one special characters (!@#$%^&*).`}</p>
                        <p className='font-bold'>{`Please follow ACGT password Policy.`}</p>
                    </div>
                </div>
            </div>
            <div className='flex py-1'>
                <p className='min-w-[250px]'>First Name:</p>
                <input type="text" className='border border-black px-2  w-[250px]' 
                value={data.FirstName}
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        FirstName: e.target.value
                    })

                    setData({...data, FirstName:e.target.value})
                }}
                />             
            </div>
            <div className='flex py-1 bg-gray-100'>
                <p className='min-w-[250px]'>Last Name:</p>
                <input type="text" className='border border-black px-2  w-[250px]' 
                value={data.LastName}
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        LastName: e.target.value
                    })

                    setData({...data, LastName:e.target.value})
                }}
                />             
            </div>
            <div className='flex py-1'>
                <p className='min-w-[250px]'>Sales:</p>
                <select name="orgname" id="orgname" className='w-[200px] border border-black'>
                    <option>{data.CorporateId}</option>
                </select>
            </div>
            <div className='flex py-1'>
                <p className='min-w-[250px]'>FedEx:</p>
                <select name="orgname" id="orgname" className='w-[100px] border border-black'
                value={data.fedexlabel} 
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        fedexlabel: e.target.value
                    })

                    setData({...data, fedexlabel:e.target.value})
                }}
                >
                    <option value={0}>No</option>
                    <option value={1}>Yes</option>
                </select>
            </div>
            <div className='flex py-1'>
                <p className='min-w-[250px]'>PI:</p>
                <input type="text" className='border border-black px-2  w-[250px]' 
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        pinvestigator: e.target.value
                    })

                    setData({...data, pinvestigator:e.target.value})
                }}
                value={data.pinvestigator} />             
            </div>
            <div className='flex py-1'>
                <p className='min-w-[250px]'>Buildings:</p>
                <input type="text" className='border border-black px-2  w-[250px]' 
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        BuildingNum: e.target.value
                    })

                    setData({...data, BuildingNum:e.target.value})
                }}
                value={data.BuildingNum} />             
            </div>
            <div className='flex py-1'>
                <p className='min-w-[250px]'>Room:</p>
                <input type="text" className='border border-black px-2  w-[250px]' 
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        RoomNum: e.target.value
                    })

                    setData({...data, RoomNum:e.target.value})
                }}
                value={data.RoomNum} />             
            </div>
            <div className='flex py-1'>
                <p className='min-w-[250px]'>Address:</p>
                <input type="text" className='border border-black px-2  w-[250px]' 
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        Address: e.target.value
                    })

                    setData({...data, Address:e.target.value})
                }}
                value={data.Address} />             
            </div>
            <div className='flex py-1'>
                <p className='min-w-[250px]'>Address2:</p>
                <input type="text" className='border border-black px-2  w-[250px]' 
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        Address2: e.target.value
                    })

                    setData({...data, Address2:e.target.value})
                }}
                value={data.Address2} />             
            </div>
            <div className='flex py-1'>
                <p className='min-w-[250px]'>City:</p>
                <input type="text" className='border border-black px-2  w-[250px]' 
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        City: e.target.value
                    })

                    setData({...data, City:e.target.value})
                }}
                value={data.City} />             
            </div>
            <div className='flex py-1'>
                <p className='min-w-[250px]'>State:</p>
                <input type="text" className='border border-black px-2  w-[250px]' value={data.State} 
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        State: e.target.value
                    })

                    setData({...data, State:e.target.value})
                }}
                />             
            </div>
            <div className='flex py-1'>
                <p className='min-w-[250px]'>Zip:</p>
                <input type="text" className='border border-black px-2  w-[250px]' value={data.Zip} 
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        Zip: e.target.value
                    })

                    setData({...data, Zip:e.target.value})
                }}
                />             
            </div>
            <div className='flex py-1 bg-gray-100'>
                <p className='min-w-[250px]'>Phone Number:</p>
                <input type="text" className='border border-black px-2  w-[250px]' value={data.PhoneNumber} 
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        PhoneNumber: e.target.value
                    })

                    setData({...data, PhoneNumber:e.target.value})
                }}
                />             
            </div>
            <div className='flex py-1 '>
                <p className='min-w-[250px]'>Fax:</p>
                <input type="text" className='border border-black px-2  w-[250px]' value={data.Fax} 
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        Fax: e.target.value
                    })

                    setData({...data, Fax:e.target.value})
                }}
                />             
            </div>
            <div className='flex py-1 bg-gray-100'>
                <p className='min-w-[250px]'>Purchasing Agent:</p>
                <input type="text" className='border border-black px-2  w-[250px]' value={data.PurchasingAgent} 
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        PurchasingAgent: e.target.value
                    })

                    setData({...data, PurchasingAgent:e.target.value})
                }}
                />             
            </div>
            <div className='flex py-1 '>
                <p className='min-w-[250px]'>Purchasing Agent Email:</p>
                <input type="text" className='border border-black px-2  w-[250px]' value={data.PurchasingAgentEmailAddress} 
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        PurchasingAgentEmailAddress: e.target.value
                    })

                    setData({...data, PurchasingAgentEmailAddress:e.target.value})
                }}
                />             
            </div>
            <div className='flex py-1 bg-gray-100'>
                <p className='min-w-[250px]'>Purchasing Agent Phone:</p>
                <input type="text" className='border border-black px-2  w-[250px]' value={data.PurchasingAgentPhoneNumber} 
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        PurchasingAgentPhoneNumber: e.target.value
                    })

                    setData({...data, PurchasingAgentPhoneNumber:e.target.value})
                }}
                />             
            </div>
            <div className='flex py-1 '>
                <p className='min-w-[250px]'>Purchasing Agent Address:</p>
                <input type="text" className='border border-black px-2  w-[250px]' value={data.PurchasingAgentAddress} 
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        PurchasingAgentAddress: e.target.value
                    })

                    setData({...data, PurchasingAgentAddress:e.target.value})
                }}
                />             
            </div>
            <div className='flex py-1 '>
                <p className='min-w-[250px]'>Purchasing Agent Address2:</p>
                <input type="text" className='border border-black px-2  w-[250px]' value={data.PurchasingAgentAddress2} 
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        PurchasingAgentAddress2: e.target.value
                    })

                    setData({...data, PurchasingAgentAddress2:e.target.value})
                }}
                />             
            </div>
            <div className='flex py-1 '>
                <p className='min-w-[250px]'>Purchasing Agent City:</p>
                <input type="text" className='border border-black px-2  w-[250px]' value={data.PurchasingAgentCity} 
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        PurchasingAgentCity: e.target.value
                    })

                    setData({...data, PurchasingAgentCity:e.target.value})
                }}
                />             
            </div>
            <div className='flex py-1 '>
                <p className='min-w-[250px]'>Purchasing Agent State:</p>
                <input type="text" className='border border-black px-2  w-[250px]' value={data.PurchasingAgentState} 
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        PurchasingAgentState: e.target.value
                    })

                    setData({...data, PurchasingAgentState:e.target.value})
                }}
                />             
            </div>
            <div className='flex py-1 '>
                <p className='min-w-[250px]'>Purchasing Agent Zip:</p>
                <input type="text" className='border border-black px-2  w-[250px]' value={data.PurchasingAgentZip} 
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        PurchasingAgentZip: e.target.value
                    })

                    setData({...data, PurchasingAgentZip:e.target.value})
                }}
                />             
            </div>
            <div className='flex py-1 bg-gray-100'>
                <p className='min-w-[250px]'>Account Status:</p>
                <select 
                name="acstatus" 
                id="acstatus" 
                className='w-[100px] border border-black' 
                value={data.AccountStatus} 
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        AccountStatus: e.target.value
                    })

                    setData({...data, AccountStatus:e.target.value})
                }}
                >
                <option value={1}>Active</option>
                <option value={2}>Inactive</option>
                </select>
            </div>
            <div className='flex py-1 '>
                <p className='min-w-[250px]'>Internal Comments:</p>
                <textarea className='border border-black w-[350px] px-2' rows={5} name="internalcomments" id="internalcomments" 
                value={data.Comments}
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        Comments: e.target.value
                    })

                    setData({...data, Comments:e.target.value})
                }}
                />
            </div>
            <div className='flex py-1 bg-gray-100'>
                <p className='min-w-[250px]'>Billing Comments:</p>
                <textarea className='border border-black w-[350px] px-2' rows={5} name="internalcomments" id="internalcomments" 
                value={data.BillingComments}
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        BillingComments: e.target.value
                    })

                    setData({...data, BillingComments:e.target.value})
                }}
                />
            </div>
            <div className='flex  py-1'>
                <p className='min-w-[250px] '>Account Created On:</p>
                <p className='font-bold'>{data.AccountCreateDateTime && data.AccountCreateDateTime.split('T')[0]}</p>
            </div>
            <div className='flex bg-gray-100 py-1'>
                <p className='min-w-[250px] '>Last Login On:</p>
                <p className='font-bold'>{data.LastLoginDateTime && data.LastLoginDateTime.split('T')[0]}</p>
            </div>
            <div className='flex  py-1'>
                <p className='min-w-[250px] '>Invoice Method:</p>
                <select 
                name="invoicemethod" 
                id="invoicemethod" 
                className='w-[140px] border border-black'
                value={data.InvoiceMethod}
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        InvoiceMethod: e.target.value
                    })

                    setData({...data, InvoiceMethod:e.target.value})
                }}
                >
                    <option value="1">Selected</option>
                    <option value="0">Not Selected</option>
                </select>
            </div>
            <div className='flex bg-gray-100 py-1'>
                <p className='min-w-[250px] '>Order Forms:</p>
                <select 
                name="orderforms" 
                id="orderforms" 
                className='w-[250px] border border-black'
                value={data.Property_OrderForms}
                onChange={(e) => {
                    setUpdateData({
                        ...updateData, 
                        Property_OrderForms: e.target.value
                    })

                    setData({...data, Property_OrderForms:e.target.value})
                }}
                >
                    <option value="1">Use Default Forms for this User</option>
                    <option value="2">Use Updated Forms for this User</option>
                </select>
            </div>

            <div className='flex justify-center mt-8 text-[14px]'>
                <button 
                onClick={() => updateContent()}
                className='bg-[var(--color-primary-purple)] text-white border border-black px-2'> Update User Account</button>
            </div>
        </div>

        <div className='flex justify-center mt-8 text-[14px]'>
            <button 
            onClick={() => window.close()}
            className='bg-[var(--color-primary-purple)] text-white border border-black px-2'> Close Window</button>
        </div>
    </div>
    </>
     :
     <p className="p-2">Loading..</p>
    }
    </>
)
}

export default EditAccount